<template>
    <div class="loader">
        <i class="fas fa-redo-alt fa-spin" aria-hidden="true"></i>
        <span>{{Language.say(props.info_text)}}</span>
    </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import Language        from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    info_text : {
      default : 'global.content.loading',
    },
  })
</script>
